<!-- <app-loading-spinner *ngIf="appService?.isLoading"></app-loading-spinner> -->

<div class="rate-agreement-container body-content-area">
    <div class="action-area">
        <div class="breadcrumb-area left-align">
            <p><a routerLink="/home"><u>Home</u> </a><span> > </span>
                <a routerLink="/home/rate-agreement"><u>Rate Agreement</u> </a><span> > </span>
                <span style="text-transform: capitalize;"> {{operation? operation:'Add'}} Rate Agreement</span>
            </p>
        </div>
        <div class="header-area left-align btn-container">
            <div style="display: flex;">
                <span class="sub-title" style="text-transform: capitalize;width: 18vw;">{{operation? operation:'Add'}} Rate Agreement</span>
                <div *ngIf="operation !== 'add'" style="display: inline-flex;align-items: center;">
                    @if(this.dataSource.RateAgreementStatusID === 39){
                        <button class="btn amber-white-btn" >Draft</button>
                    }
                    @else if(this.dataSource.RateAgreementStatusID === 36){
                        <button class="btn green-white-btn" >Active</button>
                    }
                    @else {
                        <button class="btn grey-white-btn" >{{dataSource.RateAgreementStatus}}</button>
                    }
                </div>
            </div>
           
            
            <div class="action-bts">
                <!-- <div class="icon-theme" *ngIf="operation === 'edit'" (click)="onExportAgreement()"><img src="../../../../assets/images/import-icon.png" style="transform: rotate(180deg);width: 18px;margin: 0px 2px;"><span>Export Agreement</span></div> -->
                @if(operation !== 'add' && isCopy === false && appService.enableExport){

                <div class="dropdown" [ngClass]="appService.enableExport?'enable-field':'disable-field'">
                    <!-- <button class="btn white-red-btn dropdown" (click)="dropDownSelct()" style="padding: 0px 5px"><mat-icon>add</mat-icon><span>Add Trailer</span></button> -->
                        <div class="icon-theme dropdown"(click)="dropDownSelct()"><img src="../../../../assets/images/import-icon.png" style="transform: rotate(180deg);width: 18px;margin: -3px 2px;"><span>Export Rate Agreement</span></div>
                        <div class="dropdown-content" id="agreement-drop-down" style="z-index: 100;" >
                            <div  *ngFor="let i of ['Excel','PDF']"(click)="onExportAgreement(i)">{{i}}</div>
                          </div>
                  </div>
                }
                  
                  <ng-container *ngIf="userData.RoleID === 4">
                    <div class="icon-theme" *ngIf="operation === 'edit' && this.dataSource.RateAgreementStatusID === 39 && isCopy === false" (click)="onDelete()"><mat-icon style="font-size: 21px;">delete</mat-icon><span>Delete Rate Agreement</span></div>
                    </ng-container>
                    <button mat-button-primary class="btn white-red-btn" (click)="onbackCall()">Back</button>
                    <ng-container *ngIf="userData.RoleID === 4">
                    <button mat-button-primary *ngIf="(prevOption && this.dataSource.RateAgreementStatusID === 36 && this.dataSource.IsCopy && isCopy === false && appService.enableExport)" class="btn white-red-btn" (click)="onCopy()">Copy</button>
                    <!-- <button mat-button-primary *ngIf="operation === 'edit'||(operation =='add' && isAddMaxtrix)" class="btn white-red-btn" (click)="onSave()">Save</button> -->
                    <button mat-button-primary *ngIf="(operation === 'edit' && this.dataSource.RateAgreementStatusID === 39)||(operation ==='add')" class="btn red-white-btn" (click)="onSaveBtnClicked(false)">Save</button>
                    @if(operation === 'edit' && this.dataSource.RateAgreementStatusID === 39 && isCopy === false){
                        <button mat-button-primary  class="btn red-white-btn"  (click)="onApproveBtnClick()">Approve</button>
                    }
                  </ng-container>
                
            </div>
        </div>
    </div>
    <div class="tab-area content-area">
        <!-- <mat-tab-group animationDuration="0ms" (selectedTabChange)="onTaBSelection($event)">
            <mat-tab label="Information"><mat-list role="list"  style="z-index: 1;">
                <app-agreement-information #information [copyActivity]="isCopy"></app-agreement-information>
            </mat-list></mat-tab>
            <mat-tab label="Rate Table"><mat-list role="list">
                <app-agreement-rate-table #ratetable [copyActivity]="isCopy"></app-agreement-rate-table>
            </mat-list></mat-tab>
        </mat-tab-group> -->

          <div class="tabs">
            <div class="tab-link"  [ngClass]="selectedTab===0?'active':''" (click)="onTaBSelection(0)">Information</div>
            <div class="tab-link" [ngClass]="selectedTab===1?'active':''" (click)="onTaBSelection(1)">Rate Table</div>
          </div>

          <div id="tab1" class="tab-content" [ngClass]="selectedTab===0?'active':''">
            <app-agreement-information  #information [copyActivity]="isCopy"></app-agreement-information>
          </div>
          <div id="tab2" class="tab-content" [ngClass]="selectedTab===1?'active':''">
            <app-agreement-rate-table #ratetable [copyActivity]="isCopy"></app-agreement-rate-table>
          </div>          
    </div>
    <app-export-to-pdf *ngIf="operation!='add'" [data]="dataSource" #export_pdf></app-export-to-pdf>
    <app-export-to-excel *ngIf="operation!='add'" style="display: none;" [data]="dataSource" #export_excel></app-export-to-excel>
</div>